export class NextNode {
  constructor({ id, prevId, type, isRow }) {
    this.id = id;
    this.prevId = prevId;
    this.type = type;
    this.isRow = isRow;
  }
}
